export var createPermissionState = function createPermissionState(emitNotSupportedError, window, wrapSubscribeFunction) {
  return function (permissionDescriptor) {
    return wrapSubscribeFunction(function (observer) {
      if (window === null || window.navigator === undefined || window.navigator.permissions === undefined || window.navigator.permissions.query === undefined) {
        return emitNotSupportedError(observer);
      }

      var isActive = true;

      var unsubscribe = function unsubscribe() {
        isActive = false;
      };

      window.navigator.permissions.query(permissionDescriptor).then(function (permissionStatus) {
        if (isActive) {
          observer.next(permissionStatus.state);
        }

        if (isActive) {
          permissionStatus.onchange = function () {
            return observer.next(permissionStatus.state);
          };

          unsubscribe = function unsubscribe() {
            permissionStatus.onchange = null;
          };
        }
      }, function (err) {
        if (isActive) {
          observer.error(err);
        }
      });
      return function () {
        return unsubscribe();
      };
    });
  };
};